@if ((isLoading$ | async); as isLoading) {
  <div class="loading-toast">
    <mat-spinner color="primary" [diameter]="25"></mat-spinner>
  </div>
}
